export default __webpack_public_path__ + "static/media/vtindexpro-sidebar.26e69a06.png";